module.exports = __webpack_public_path__ + "static/media/moonlightdogHero.88a7d638.jpg";